import DetailFormHead from "components/subHead/detailFormHead";

import {
  dateFormat,
  getDay,
  getToday,
  priceFormat,
  timeFormat,
} from "components/utils/comm";
import { useTranslation } from "react-i18next";
import { useCancelResv, useGetCancelFeeData, useGetData } from "./service";
import i18n from "locales/i18n";
import BaseInfLoaing from "components/detailLoading/baseInf";
import { useLayoutEffect, useRef, useState } from "react";
import LodInfRow from "components/rows/lodRow";
import TableRow from "components/rows/tableRow";
import Cell from "components/rows/cell";
import BaseModal from "components/modal/base";
import { useResvCancelContext } from "./context";

export default function ResvDetail() {
  const { t } = useTranslation();
  const langCd = i18n.language;
  const { resvInf, payInf, isLoading, isSuccess } = useGetData();
  const today = getToday();

  const { openResvCancelModal, setOpenResvCancelModal } =
    useResvCancelContext();

  /**
   * 객실 예약취소 수수료 조회
   * 객실 예약 취소
   */

  // 객실 타입

  return (
    <>
      {/* 기본정보 */}
      <DetailFormHead title={t("sub_ttl_rm_default")} />
      {(!resvInf || isLoading) && (
        <BaseInfLoaing rowTitle={t("row_ttl_rm_inf")} isData={isSuccess} />
      )}
      {resvInf && (
        <table>
          <tbody>
            <LodInfRow />
          </tbody>
          <TableRow title={t("row_ttl_rm_inf")}>
            <ul>
              <li>
                <Cell label={t("lbl_rm_nm")} value={resvInf?.rmNm} />
              </li>
              <li>
                <Cell label={t("lbl_rm_typ")} value={resvInf?.rmTypNm} />
              </li>
              <li>
                <Cell label={t("lbl_rm_olk")} value={resvInf?.rmOlkNm} />
              </li>
              <li>
                <Cell label={t("lbl_bad_typ")} value={resvInf?.bedTypNm} />
              </li>
              <li>
                <Cell label={t("lbl_max_per_ct")} value={resvInf?.maxPerCt} />
              </li>
              <li>
                <Cell
                  label={t("lbl_brkf")}
                  value={
                    resvInf?.brkfInYn === "Y"
                      ? t("included_y")
                      : t("included_n")
                  }
                />
              </li>
            </ul>
          </TableRow>
        </table>
      )}
      {/* 상품정보 */}
      <DetailFormHead title={t("sub_ttl_rmpd_inf")} />
      {(!resvInf || isLoading) && (
        <BaseInfLoaing rowTitle={t("row_ttl_rmpd")} isData={isSuccess} />
      )}
      {resvInf && (
        <table>
          <tbody>
            <TableRow title={t("row_ttl_rmpd")}>
              <ul>
                <li>
                  <Cell label={t("lbl_rmpd_no")} value={resvInf?.rmPdNo} />
                </li>
                <li>
                  <Cell
                    label={t("lbl_rmpd_dt")}
                    value={dateFormat(resvInf?.sellDt, "-")}
                  />
                </li>
                <li>
                  <Cell
                    label={t("lbl_rmpd_day")}
                    value={getDay({ dayNm: resvInf?.dowV, langCd }) ?? "--"}
                  />
                </li>
                <li>
                  <Cell
                    label={t("lbl_rmpd_price")}
                    value={
                      priceFormat({
                        price: resvInf?.sellPri,
                        payLangCd: payInf?.payLangCd,
                      }) ?? "--"
                    }
                  />
                </li>
                <li>
                  <Cell label={t("lbl_rmpd_chl")} value={resvInf?.lodChlNm} />
                </li>
                <li>
                  <Cell label={t("lbl_prom_cd")} value="--" />
                </li>
                <li>
                  <Cell label={t("lbl_prom_nm")} value="--" />
                </li>
                <li>
                  <Cell label={t("lbl_prom_price")} value="--" />
                </li>
              </ul>
            </TableRow>
          </tbody>
        </table>
      )}

      {/* 예약정보 */}
      <DetailFormHead title={t("sub_ttl_resv_inf")} />
      {(!resvInf || isLoading) && (
        <BaseInfLoaing rowTitle={t("row_ttl_resv")} isData={isSuccess} />
      )}
      {resvInf && (
        <table>
          <tbody>
            <TableRow title={t("row_ttl_resv")}>
              <ul>
                <li>
                  <Cell
                    label={t("lbl_resv_no")}
                    labelFor="bold"
                    value={resvInf?.rmResvNo}
                  />
                </li>
                <li>
                  <Cell label={t("lbl_resv_sequence")} value="1" />
                </li>
                <li>
                  <Cell
                    label={t("lbl_pay_amt")}
                    value={
                      priceFormat({
                        price: resvInf?.resvSumAmt,
                        payLangCd: payInf?.payLangCd,
                      }) ?? "--"
                    }
                  />
                </li>
                <li>
                  <Cell
                    label={t("lbl_check_in_dt")}
                    labelFor="bold"
                    value={dateFormat(resvInf.resvSDt)}
                  />
                </li>
                <li>
                  <Cell
                    label={t("lbl_check_out_dt")}
                    labelFor="bold"
                    value={dateFormat(resvInf?.resvEDt)}
                  />
                </li>
                <li>
                  <Cell
                    label={t("lbl_resv_day_ct")}
                    value={resvInf?.resvDayCt}
                  />
                </li>
                <li>
                  <Cell label={t("lbl_resv_rm_ct")} value={resvInf?.resvRmCt} />
                </li>
                <li>
                  <Cell
                    label={t("lbl_resv_per_ct")}
                    value={resvInf?.resvPerCt}
                  />
                </li>
                <li>
                  <Cell
                    label={t("lbl_adlt_per_ct")}
                    value={resvInf?.adltPerCt}
                  />
                </li>
                <li>
                  <Cell
                    label={t("lbl_chld_per_ct")}
                    value={resvInf?.chldPerCt}
                  />
                </li>
                <li>
                  <Cell
                    label={t("lbl_baby_per_ct")}
                    value={resvInf?.babyPerCt}
                  />
                </li>
                <li>
                  {resvInf?.resvStaCd === "RS00" && today < resvInf.sellDt && (
                    <>
                      <label htmlFor="bold">{t("lbl_resv_cnl")}</label>
                      {/* 예약취소 버튼 */}
                      <button
                        className="btn bg-red-500"
                        // disabled={disabled}
                        onClick={() => setOpenResvCancelModal(true)}
                      >
                        {t("btn_resv_cnl")}
                      </button>
                    </>
                  )}
                  {resvInf?.resvStaCd === "RS00" && today >= resvInf.sellDt && (
                    <>
                      <label htmlFor="bold">{t("lbl_resv_cnl_sts")}</label>
                      <p className="flex items-center px-4 rounded-sm border border-gray-400 h-[22px]  bg-gray-200 text-black-900 font-bold">
                        {t("status_resv_done")}
                      </p>
                    </>
                  )}
                  {resvInf?.resvStaCd === "RC00" && (
                    <>
                      <label htmlFor="bold">{t("lbl_resv_cnl_sts")}</label>
                      <p className="flex items-center px-4 rounded-sm border border-gray-400 h-[22px]  bg-gray-200 text-red-300 font-bold">
                        {/* {t("txt_resv_cnl")} */}
                        취소완료
                      </p>
                    </>
                  )}
                </li>
                <li>
                  <Cell
                    label={t("lbl_resv_mail_send_dt")}
                    value={dateFormat(resvInf?.rmPdResvDt)}
                  />
                </li>
                <li>
                  <Cell
                    label={t("lbl_resv_fax_send_dt")}
                    value={dateFormat(resvInf?.rmPdResvDt)}
                  />
                </li>
                <li>
                  <Cell
                    label={t("lbl_mem_nm")}
                    value={
                      (resvInf?.resvMemSurnm ?? "") +
                        (resvInf.resvMemFstnm ?? "") || "--"
                    }
                  />
                </li>
                <li>
                  <Cell
                    label={t("lbl_mem_phone_no")}
                    value={resvInf?.resvMemMobNo || "--"}
                  />
                </li>
                <li>
                  <Cell
                    label={t("lbl_cst_nm")}
                    value={
                      (resvInf?.resvCstSurnm ?? "") +
                      (resvInf.resvCstFstnm ?? "")
                    }
                  />
                </li>
                <li>
                  <Cell
                    label={t("lbl_cst_phone")}
                    value={resvInf?.resvCstMblNo}
                  />
                </li>
                <li>
                  <Cell label={t("lbl_cst_eml")} value={resvInf?.resvCstEml} />
                </li>
                <li className="w-full">
                  <Cell label={t("lbl_req_cn")} value={resvInf?.reqCn} />
                </li>
              </ul>
            </TableRow>
          </tbody>
        </table>
      )}

      <DetailFormHead title={t("sub_ttl_pay")} />
      {(!resvInf || isLoading) && (
        <BaseInfLoaing rowTitle={t("row_ttl_pay")} isData={isSuccess} />
      )}
      {payInf && (
        <>
          <table>
            <tbody>
              <TableRow title={t("row_ttl_pay")}>
                <ul>
                  <li>
                    <Cell
                      label={t("lbl_resv_rg_seq")}
                      value={payInf?.payRgSeq}
                    />
                  </li>
                  <li>
                    <Cell
                      label={t("lbl_pay_dt")}
                      value={
                        dateFormat(payInf.tranDtti.slice(0, 8)) +
                        "  " +
                        timeFormat(payInf.tranDtti.slice(8))
                      }
                    />
                  </li>
                  <li>
                    <Cell
                      label={t("lbl_pay_price")}
                      labelFor="bold"
                      value={
                        priceFormat({
                          price: payInf?.payAmt,
                          payLangCd: payInf?.payLangCd,
                        }) ?? "--"
                      }
                    />
                  </li>
                  <li>
                    <Cell
                      label={t("lbl_pay_sts")}
                      labelFor="bold"
                      value={
                        payInf?.payStaCd === "RP01"
                          ? t("status_pay_reques")
                          : payInf?.payStaCd === "RP02"
                          ? t("status_pay_progress")
                          : payInf?.payStaCd === "RP00"
                          ? t("status_pay_done")
                          : "--"
                      }
                    />
                  </li>
                  <li>
                    <Cell label={t("lbl_crr_cmm")} value={payInf?.currCd} />
                  </li>
                  <li>
                    <Cell
                      label={t("lbl_inst_month")}
                      value={
                        payInf?.instMont === "00"
                          ? t("txt_pay_one_time")
                          : payInf.instMont
                      }
                    />
                  </li>
                  <li>
                    <Cell
                      label={t("lbl_pay_method_nm")}
                      value={payInf?.payMethodNm}
                    />
                  </li>
                  <li>
                    <Cell
                      label={t("lbl_pay_lang_cd")}
                      value={payInf?.payLangCd}
                    />
                  </li>
                  <li>
                    <Cell
                      label={t("lbl_pay_method")}
                      value={payInf?.payMethodNm}
                    />
                  </li>
                  <li className="">
                    <Cell
                      label={t("lbl_pay_card_no")}
                      value={
                        payInf?.cardNum1 +
                        "-" +
                        "✴︎✴✴︎✴" +
                        "-" +
                        "✴︎✴✴︎✴" +
                        "-" +
                        payInf?.cardNum4
                      }
                    />
                  </li>
                  <li>
                    <Cell label={t("lbl_other_pay")} value={"--"} />
                  </li>
                  <li>
                    <Cell label={t("lbl_by_nm")} value={payInf?.buyerNm} />
                  </li>
                  <li>
                    <Cell label={t("lbl_by_eml")} value={payInf?.buyerEml} />
                  </li>
                </ul>
              </TableRow>
            </tbody>
          </table>
        </>
      )}

      {/* 예약 취소 정보 확인 모달창 */}
      {openResvCancelModal && (
        <BaseModal
          isOpen={openResvCancelModal}
          title={t("sub_ttl_resv_cancel")}
          onClose={() => setOpenResvCancelModal(false)}
        >
          <CancelFee
            rmPdNo={resvInf?.rmPdNo}
            resvSumAmt={resvInf?.resvSumAmt}
          />
        </BaseModal>
      )}
    </>
  );
}

type ICancelFee = {
  resvSumAmt: string | undefined;
  rmPdNo: string | undefined;
};
const CancelFee = ({ rmPdNo, resvSumAmt }: ICancelFee) => {
  const { t } = useTranslation();
  const langCd = i18n.language;

  const { cancelFee } = useGetCancelFeeData(rmPdNo);
  const { onCancelResv } = useCancelResv();
  const { setOpenResvCancelModal } = useResvCancelContext();

  const txtRef = useRef<HTMLParagraphElement | null>(null);

  const refAmtInf = {
    ...cancelFee,
    resvSumAmt,
  };

  useLayoutEffect(() => {
    if (txtRef.current) {
      txtRef.current.innerHTML = t("txt_ref_des");
    }
  }, [t]);

  const CancelAlert = ` <div>
         객실예약을 취소하면 <br />
         취소 수수료 <span class="text-red-300 font-bold">
           ${priceFormat({
             price: refAmtInf?.cnlFeeAmt,
             payLangCd: langCd,
           })}
         </span>
         발생합니다. <br />
         예약을 취소하시겠습니까?
       </div>`;

  return (
    <>
      <div className="w-full flex justify-between items-center pb-2"></div>
      <ul className="flex col gap-1">
        <li className="flex">
          <label htmlFor="">{t("lbl_rm_cnt")}</label>
          <input
            type="text"
            className="border-0"
            defaultValue={refAmtInf?.rmPdCt}
            readOnly
          />
        </li>
        <li className="flex">
          <label htmlFor="">{t("lbl_pay_amt")}</label>
          <input
            type="text"
            className="border-0"
            value={priceFormat({
              price: refAmtInf?.resvSumAmt,
              payLangCd: langCd,
            })}
            readOnly
          />
        </li>
        <li className="flex">
          <label htmlFor="" className="text-red-300">
            {t("lbl_cnl_fee_amt")}
          </label>
          <input
            type="text"
            className="border-0 font-bold text-red-300"
            value={priceFormat({
              price: refAmtInf?.cnlFeeAmt,
              payLangCd: langCd,
            })}
            readOnly
          />
        </li>
        <li className="flex">
          <label htmlFor="" className="text-green-500">
            {t("lbl_ref_amt")}
          </label>
          <input
            type="text"
            className="border-0 font-bold text-green-500"
            value={priceFormat({
              price: refAmtInf?.refAmt,
              payLangCd: langCd,
            })}
            readOnly
          />
        </li>
        <li className="text-xs text-red-300 my-2 px-2 text-center ">
          <p ref={txtRef} />
        </li>
      </ul>
      <div className="flex justify-center gap-3 pt-4">
        <button
          className="btn bg-red-300"
          onClick={() =>
            onCancelResv({
              rmPdNo,
              inner: CancelAlert,
            })
          }
        >
          {t("btn_resv_cnl")}
        </button>
        <button
          className="btn bg-gray-400"
          onClick={() => setOpenResvCancelModal(false)}
        >
          {t("btn_cancel")}
        </button>
      </div>
    </>
  );
};
